<template>
    <div>

        <div class="flex gap-2 pb-2 pt-2" >
            <div v-if="required" class="text-rose-500">*</div>
            <label for="{{label}}" class="block text-sm font-medium text-gray-700">{{label}}</label>
        </div>

        <div class="flex-col gap-2">
            <div class="cursor-pointer">
                <span class="hiddenFileInput">
                    <input type="file" multiple accept="text/html, video/*, audio/*, .pdf, application/vnd.ms-excel, .csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, text/plain, image/*" @change="selectFiles"  />
                </span>
            </div>

            <div class="w-full" v-if="!hideList">
                <UploadFileList :files="files" :onDelete="deleteFile" />
            </div>        
        </div>

    </div>
</template>

<script>
import UploadFileList from '_app/resources/components/elements/UploadFileList.vue';

export default {
    
    name: 'upload',

    components: {
        UploadFileList,
    },

    props: {

        label: {
            type: String,
            required: false,
        },
        required: {
            type: Boolean,
            default: false,
            required: false,
        },

        restart: {
            type: [String, Boolean, Number],
            default: 0,
            required: false,
        },

        category: {
            type: String,
            default: '',
            required: false,
        },


        modelValue: [Array, Object],

        hideList: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            urlUpload: 'upload',
            files: [],
            user: this.$SessionService.getUser(),
        }
    },
    methods: {
        uploadFiles(files) {
            for (let i = 0; i < files.length; i++) {
                // Se o arquivo não for encontrado na lista, adiciona ele
                if (this.files.findIndex(file => file.name == files[i].name) == -1) {
                    files[i].status = 'upload';
                    files[i].name_server = files[i].name;
                    this.files.push(files[i]);
                }
            }

            this.$emit('update:modelValue', this.filesUploaded())
        },

        selectFiles(event) {
            const files = event.target.files;
            for (let i = 0; i < files.length; i++) {
                // Se o arquivo não for encontrado na lista, adiciona ele
                if (this.files.findIndex(file => file.name == files[i].name) == -1) {
                    files[i].status = 'upload';
                    files[i].name_server = files[i].name;
                    this.files.push(files[i]);
                }
            }

            this.$emit('update:modelValue', this.filesUploaded())

        },
        
        deleteFile(file) {
            this.files.splice(this.files.findIndex(file => file.name == file.name), 1);
            this.$emit('update:modelValue', this.filesUploaded())
        },

        filesUploaded() {
            
            //return this.files;

            let listFiles = [];
            for (let i = 0; i < this.files.length; i++) {
                //if (this.files[i].status == 'uploaded') {

                    listFiles.push(
                        {
                            name: this.files[i].name,
                            name_server: this.files[i].name_server || '',
                            status: this.files[i].status,
                            url: this.files[i].url || '',
                        }
                    );
                //}
            }
            return listFiles;
        },

        async uploadFile(file){

            let formData = new FormData();
            formData.append('file', file);
            formData.append('root_owners_id', this.user.root_owners_id);
            formData.append('category', this.category);
            
            await this.$http.post(this.urlUpload, formData, {headers: {'Content-Type': 'multipart/form-data'}}            
            ).then(response => {

                file.status = 'uploaded';
                file.name_server = response.data.file;
                file.url = response.data.url || response.data.location || '';
                
                for (let i = 0; i < this.files.length; i++) {                
                    if (this.files[i].name == file.name) {
                        this.files[i] = file;
                    }
                }

                // altera a posição do último elemento para o primeiro / força reload do
                this.files.unshift(this.files.splice(this.files.findIndex(file => file.name == file.name), 1)[0]);

                this.$emit('update:modelValue', this.filesUploaded())



            }).catch(error => {
                file.status = 'error';
                file.name_server = '';
                for (let i = 0; i < this.files.length; i++) {
                    if (this.files[i].name == file.name) {
                        this.files[i] = file;
                    }
                }

                // altera a posição do último elemento para o primeiro / força reload do
                this.files.unshift(this.files.splice(this.files.findIndex(file => file.name == file.name), 1)[0]);
                this.$emit('update:modelValue', this.filesUploaded())
            });
        },

        async startUpload() {
            this.files.forEach(file => {
                if (file.status == 'upload') {
                    file.status = 'uploading';
                     this.uploadFile(file);
                }
            });
        },

        status(status) {
            switch (status) {
                case 'upload':
                    return '<div class="text-gray-600">◉</div>';
                case 'uploading':
                    return '<div class="text-amber-600">◉</div>';
                case 'uploaded':
                    return '<div class="text-green-600">◉</div>';
                case 'error':
                    return '<div class="text-rose-600">◉</div>';
                default:
                    return '<div class="text-gray-600">◉</div>';
            }
        },

        statusTXT(status) {
            switch (status) {
                case 'upload':
                    return '<div class="text-gray-600"></div>';
                case 'uploading':
                    return '<div class="text-gray-600 text-xs flex gap-2 itens-center border rounded p-1">Enviando <img src="/imgs/loading.gif" width="15px"></div>';
                case 'uploaded':
                    return '<div class="text-green-600"></div>';
                case 'error':
                    return '<div class="text-rose-600">Erro ao enviar</div>';
                default:
                    return '<div class="text-gray-600"></div>';
            }
        }        



    },

    watch: {
        files: {
            handler(newValue, oldValue) {            
                this.startUpload();
            },
            deep: true,
        },

        restart: {
            handler(newValue, oldValue) {
                if (newValue) {
                    this.files = [];
                    this.$emit('update:modelValue', this.filesUploaded())
                }
            },
            deep: true,
        },
    },

};
</script>

  <style scoped>
    .progress-bar {
        opacity: 1;
        height: 2px;
        margin: 0.4em 0;
        width: 0;
        background: green;
    }

    .hiddenFileInput > input{
        height: 100%;
        width: 100;
        opacity: 0;
        cursor: pointer;
    }
    .hiddenFileInput{
        border: 1px solid #ccc;
        border-radius: 10px;
        width: 50px;
        height: 50px;
        display: inline-block;
        overflow: hidden;
        cursor: pointer;
    
        /*for the background, optional*/
        background: center center no-repeat;
        background-size: 55% 55%;
        background-image:  url(data:image/svg+xml;utf8;base64,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)
    }    

  </style>